
interface ErrorResponse {
    response: {
        data: {
            error: {
                message: string | string[] | Record<string, string>;
            }
        };
    };
}


export function extractErrorMessage(error: unknown): string | null {
    if (
        typeof error === "object" &&
        error !== null &&
        "response" in error &&
        typeof (error as ErrorResponse).response === "object"
    ) {
        const { response } = error as ErrorResponse;
        const { data } = response;

        // Check if data exists before destructuring
        if (!data || typeof data !== "object") {
            return null;
        }

        const { message } = data.error;

        if (typeof message === "string") return message;
        if (Array.isArray(message)) return message.join(", ");
        if (typeof message === "object" && message !== null) {
            return Object.values(message).join(", ");
        }
    }
    return null;
}